var d3 = {
  ...require("d3-axis/dist/d3-axis.min"),
  ...require("d3-scale/dist/d3-scale.min"),
  ...require("d3-selection/dist/d3-selection.min"),
  ...require("d3-shape/dist/d3-shape.min"),
  ...require("d3-interpolate/dist/d3-interpolate.min")
};

var { COLORS, classify, makeTranslate } = require("./lib/helpers");
var { yearFull, yearAbbrev } = require("./lib/helpers/formatDate");
var { isMobile } = require("./lib/breakpoints");

// Render a line chart.
module.exports = function(config) {

  // Setup
  var { dateColumn, valueColumn } = config;

  var aspectWidth = isMobile.matches ? 4 : 4;
  var aspectHeight = isMobile.matches ? 3 : 4;

  var margins = {
    top: 14,
    right: 30,
    bottom: 30,
    left: 12
  };

  var ticksX = 10;
  var ticksY = 10;
  var roundTicksFactor = 5;

  // Mobile
  if (isMobile.matches) {
    ticksX = 5;
    ticksY = 5;
    margins.right = 25;
  }

  // Calculate actual chart dimensions
  var chartWidth = config.width/4 - margins.left - margins.right;
  var chartHeight =
    Math.ceil((config.width/4 * aspectHeight) / aspectWidth) -
    margins.top -
    margins.bottom;

  if (isMobile.matches) {
    var chartWidth = config.width/2 - margins.left - margins.right;
    var chartHeight =
      Math.ceil((config.width/2 * aspectHeight) / aspectWidth) -
      margins.top -
      margins.bottom;
  }

  // Clear existing graphic (for redraw)
  var containerElement = d3.select(config.container);
  containerElement.html("");

  var dates = config.data[0].values[0].values.map(d => d.date);
  var extent = [dates[0], dates[dates.length-1]];

  var xScale = d3
    .scaleLinear()
    .domain(extent)
    .range([0, chartWidth]);

  var min = 0.5;
  var max = 1;

  var yScale = d3
    .scaleLinear()
    .domain([min, max])
    .range([chartHeight, 0]);

  var colorScale = d3
    .scaleOrdinal()
    .domain(["Male", "Female"])
    .range([COLORS.teal2, COLORS.peach2]);

  // Render the HTML legend.

  var oneLine = config.data.length > 1 ? "" : " one-line";

  var legend = containerElement
    .append("ul")
    .attr("class", "key" + oneLine)
    .selectAll("g")
    .data(config.data[0].values)
    .enter()
    .append("li")
    .attr("class", d => "key-item " + classify(d.name));

  legend.append("b").style("background-color", d => colorScale(d.name));

  legend.append("label").text(d => d.name);

  // Create the root SVG element.

  var chartWrapper = containerElement
    .selectAll("div")
    .data(config.data)
    .enter()
    .append("div")
    .attr("class", "graphic-wrapper");

  var chartLabel = chartWrapper
    .append("h3")
    .attr("class", "graphic-header")
    .text(d => d.group);

  var chartElement = chartWrapper
    .append("svg")
    .attr("width", chartWidth + margins.left + margins.right)
    .attr("height", chartHeight + margins.top + margins.bottom)
    .append("g")
    .attr("transform", `translate(${margins.left},${margins.top})`);

  // Create D3 axes.

  var xAxis = d3
    .axisBottom()
    .scale(xScale)
    .tickValues(["2017","2018","2019", "2020"])
    .tickSize(0)
    .tickFormat(d => "'" + d.slice(-2));

  var yAxis = d3
    .axisLeft()
    .scale(yScale)
    .tickValues([0.5,0.6, 0.7, 0.8, 0.9,1])
    .tickFormat(d => d*100+"%");

  // Render axes to chart.

  chartElement
    .append("g")
    .attr("class", "x axis")
    .attr("transform", makeTranslate(0, chartHeight + 10))
    .call(xAxis);

  // chartElement
  //   .append("g")
  //   .attr("class", "y axis")
  //   .call(yAxis);

  // Render grid to chart.

  var xAxisGrid = function() {
    return xAxis;
  };

  var yAxisGrid = function() {
    return yAxis;
  };

  chartElement
    .append("g")
    .attr("class", "x grid")
    .attr("transform", makeTranslate(0, chartHeight))
    .call(
      xAxisGrid()
        .tickSize(-chartHeight, 0, 0)
        .tickFormat("")
    );

  chartElement
    .append("g")
    .attr("class", "y grid")
    .call(
      yAxisGrid()
        .tickSize(-chartWidth, 0, 0)
        .tickFormat("")
    );


  // Render lines to chart.
  var line = d3.line()
    .x(d => xScale(d[dateColumn]))
    .y(d => yScale(d[valueColumn]));

  var area = d3.area()
    .x(d => xScale(d[dateColumn]))
    .y0(d => yScale(d.Male))
    .y1(d => yScale(d.Female))

  var areaChart = chartElement
    .append("g")
    .attr("class", "area")
    .append("path")
    .datum(d => DATA.filter(function(a) {
      return a.Group == d.group})
    )
    .attr("fill", COLORS.gray3)
    .attr("d", d => area(d));

  chartElement
    .append("g")
    .attr("class", "lines")
    .selectAll("path")
    .data(d => d.values)
    .enter()
    .append("path")
    .attr("class", d => "line " + classify(d.name))
    .attr("stroke", d => colorScale(d.name))
    .attr("d", d => line(d.values));


  chartElement
    .append("g")
    .selectAll("male")
    .data(d => d.values[0].values)
    .enter()
    .append("text")
    .attr("class", d => "values male year-" + d.date)
    .attr("x", d => xScale(d.date) + 4)
    .attr("y", d => yScale(d.amt) + 16)
    .attr("text-anchor", "middle")
    .text(d => Math.round(d.amt*100)+"%");

  chartElement
    .append("g")
    .selectAll("female")
    .data(d => d.values[1].values)
    .enter()
    .append("text")
    .attr("class", d => "values female year-" + d.date)
    .attr("x", d => xScale(d.date) + 4)
    .attr("y", d => yScale(d.amt) - 8)
    .attr("text-anchor", "middle")
    .text(d => Math.round(d.amt*100)+"%");

};
